export default __webpack_public_path__ + "static/webpack-cd42336a0bc60520a2949869b5d400c9.png";